import base from './baseApi';
const { get } = base();

export const geocoding = (searchText: any, limit: any, country: any) => {
   return get(`/common/geocoding/places`, { searchText, limit, country });
};

export const searchBoxSuggest = (
   searchText: any,
   limit: any,
   siteId?: string,
   country?: string,
   proximity?: string,
   includeLodging: boolean = false,
   biasCountries?: readonly string[],
) => {
   const params: any = { searchText, limit };
   if (siteId) {
      params.siteId = siteId;
   }
   if (country) {
      params.country = country;
   }
   if (proximity) {
      params.proximity = proximity;
   }
   if (includeLodging) {
      params.includeLodging = includeLodging;
   }
   // NPT-2053 — rerank preference (the market's searchBiasCountries). Only a rerank: the scope
   // stays the API's. A hard `country` filter makes it moot, so it is left off then. The default
   // market (US alone) is left off too: the API's no-bias order is today's US-first ranking,
   // while an explicit ['US'] would also lift CA/MX over Europe (London ON above London UK).
   const isDefaultBias = biasCountries?.length === 1 && biasCountries[0]?.toUpperCase() === 'US';
   if (biasCountries?.length && !country && !isDefaultBias) {
      params.biasCountries = biasCountries.join(',');
   }
   return get(`/common/searchBox/suggest`, params);
};

export const searchBoxRetrieve = (mapboxId: any, siteId?: string) => {
   const params: any = {};
   if (siteId) {
      params.siteId = siteId;
   }
   return get(`/common/searchBox/retrieve/` + mapboxId, params);
};
